<template>
  <div>
    <div
      class="exibe-banner-upgrade"
      v-if="exibeBotaoUpgrade"
      @click="setToggleBannerUpgrade"
      v-b-tooltip.hover.window.top
      title="Conheça as versões Premium!"
    >
      <font-awesome-icon class="exibe-banner-upgrade-icone" icon="bolt" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BotaoBannerUpgrade",
  props: {
    exibeBotaoUpgrade: Boolean,
    setToggleBannerUpgrade: Function
  }
};
</script>

<style lang="scss" scoped>
.exibe-banner-upgrade {
  color: var(--branco);
  background: var(--azul4);
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 25px;
  margin-left: 10px;
  cursor: pointer;
  box-shadow: 2px 2px 4px var(--sombra2);
}
.exibe-banner-upgrade-icone {
  height: 25px;
  width: 25px;
}
</style>
